export default __webpack_public_path__ + "static/media/nav-gestao-saude.48dc99ea.svg";